import { RegisterResponse, RegisterType } from 'api';

const hasValue = (value?: string | null) => !!value?.trim();

export const hasIncompleteRegistrationFields = (
  registerObj: RegisterResponse | undefined,
): boolean => {
  if (!registerObj) return false;

  const requiresTrustee = registerObj.type !== RegisterType.Company;

  return (
    !hasValue(registerObj.ACN) ||
    !hasValue(registerObj.abn) ||
    (requiresTrustee && !hasValue(registerObj.trustee)) ||
    !hasValue(registerObj.registered_office)
  );
};
